import { observer } from 'mobx-react-lite';
import { useEffect, useRef } from 'react';
import toastStore, { ToastItem } from '../../../stores/toastStore';
import { twMerge } from 'tailwind-merge';

const Toast = observer(({ toast }: { toast: ToastItem }) => {
    const ref = useRef<HTMLDivElement>(null);

    // PopOver API 를 사용해서 처리
    useEffect(() => {
        if (ref.current && toast.state === 'ready') {
            ref.current.showPopover();
        } else if (ref.current && toast.state === 'hidden') {
            ref.current.hidePopover();
        }
    }, [toast.state]);

    return (
        <div
            ref={ref}
            popover="manual"
            className={twMerge(
                'toast-item', // 기본 스타일은 index.css 에서 처리함
                'text-base-content bg-base-200 flex items-center justify-center rounded px-3 py-1 text-xs shadow',
                // 토스트가 나올 때에는 네이티브 popoveer 에 애니메이션 효과가 있음
                // 사라질 때에만 opacity 처리해줌
                toast.state === 'hiding' && 'opacity-0',
            )}
        >
            {toast.message}
        </div>
    );
});

export const ToastContainer = observer(() => {
    return (
        <div id="toast-container" className="toast toast-bottom toast-center">
            {Array.from(toastStore.toasts.values()).map((toast) => (
                <Toast key={toast.id} toast={toast} />
            ))}
        </div>
    );
});
